import Vue from 'vue';
import { MutationTree } from 'vuex';
import { PostgradStudentDocumentsState } from './state';
import { CourseCertificateInfo } from '@/models/studentDocuments';
import { StudentDocumentsStatusInfo } from '@/helpers/postgradStudentDocuments/interfaces';

const mutations: MutationTree<PostgradStudentDocumentsState> = {
  SET_POSTGRAD_STUDENT_DOCUMENTS_STATUS(
    state,
    {
      documentsStatus,
      courseId,
    }: { documentsStatus: StudentDocumentsStatusInfo; courseId: number },
  ) {
    Vue.set(state.documentsStatus, courseId.toString(), documentsStatus);
  },
  SET_POSTGRAD_STUDENT_CERTIFICATE_INFO(
    state,
    payload: CourseCertificateInfo & { courseId: number },
  ) {
    const { courseId, ...certificateInfo } = payload;

    Vue.set<CourseCertificateInfo>(state.certificateInfo, courseId.toString(), certificateInfo);
  },
};

export default mutations;
